import React, { FC, ReactNode } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { themeByCSSVariables, withTheme } from '@shared/lib/theme';
import { Text, Marquee } from '@shared/ui/atoms';
import { ICON_TCP } from '@shared/config';
import { getSingleTspType, TspPageDenomination, TspPagePayee, TspType, useCyberStore } from '@entities/tsp';
import { parseDenominationAmount } from '../lib/parseDenominationAmount';
import { checkIsDenominationSelected } from '../lib/checkIsDenominationSelected';
import keyDenominationCoverImage from '../assets/key-denomination-cover.webp';
interface DenominationCardProps {
  payee: TspPagePayee;
  denomination: TspPageDenomination;
  isSoldOut: boolean;
  button: ReactNode;
}
const DenominationCard: FC<DenominationCardProps> = ({
  payee,
  denomination,
  isSoldOut,
  button
}) => {
  const {
    activeDenomination,
    setActiveDenomination
  } = useCyberStore();
  const {
    baseAmount,
    bonusAmount,
    currency
  } = parseDenominationAmount(denomination.features?.buttonLabel as string);
  const type = getSingleTspType(payee);
  const handleDenominationSelect = () => {
    if (!isSoldOut) {
      setActiveDenomination(denomination);
    }
  };
  const isSelected = checkIsDenominationSelected(denomination, activeDenomination);
  return <DenominationCardWrapper isSelected={isSelected} isSoldOut={isSoldOut} color={type === TspType.KEYS ? themeByCSSVariables.colors.background.accent : `#${denomination.features?.colorsubcategory}`} onClick={handleDenominationSelect}>
      <ImageWrapper>
        <Image src={type === TspType.KEYS ? keyDenominationCoverImage : `${ICON_TCP}${denomination.features?.buttonIcon}`} alt="denomination" width={236} height={140} />
      </ImageWrapper>
      <BottomContentWrapper>
        <MarqueeWrapper>
          <Marquee enabled={isSelected}>
            <LabelWrapper>
              <AmountWrapper>
                {type !== TspType.KEYS && <IconWrapper>
                    <Image src={`${ICON_TCP}${denomination.features?.iconsubcategory}`} alt="denomination" width={20} height={20} />
                  </IconWrapper>}
                <Text family="MTSCompact" weight="bold" size={{
                desktop: 'pM',
                mobile: 'captionM'
              }} color="primary">
                  {baseAmount === 0 ? denomination.features?.buttonLabel : <>
                      {baseAmount} {type === TspType.SERVICES && currency}
                    </>}
                </Text>
              </AmountWrapper>
              {Boolean(bonusAmount) && <>
                  <Text family="MTSCompact" weight="bold" size={{
                desktop: 'pM',
                mobile: 'captionM'
              }} color="primary">
                    +
                  </Text>
                  <AmountWrapper>
                    {type !== TspType.KEYS && <IconWrapper>
                        <Image src={`${ICON_TCP}${denomination.features?.iconsubcategory}`} alt="denomination" width={20} height={20} />
                      </IconWrapper>}
                    <Text family="MTSCompact" weight="bold" size={{
                  desktop: 'pM',
                  mobile: 'captionM'
                }} color={`#${denomination.features?.colorsubcategory}`}>
                      {bonusAmount}
                    </Text>
                  </AmountWrapper>
                </>}
            </LabelWrapper>
          </Marquee>
        </MarqueeWrapper>
        <ButtonWrapper>{button}</ButtonWrapper>
      </BottomContentWrapper>
    </DenominationCardWrapper>;
};
export default DenominationCard;
interface DenominationCardWrapperProps {
  isSelected: boolean;
  isSoldOut: boolean;
  color: string;
}
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.secondary;
const _exp2 = /*#__PURE__*/() => ({
  isSelected,
  color
}) => isSelected ? color : 'transparent';
const _exp3 = /*#__PURE__*/() => ({
  isSoldOut
}) => isSoldOut ? 'default' : 'pointer';
const DenominationCardWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "DenominationCardWrapper",
  class: "dwqt35n",
  propsAsIs: false,
  vars: {
    "dwqt35n-0": [_exp()],
    "dwqt35n-1": [_exp2()],
    "dwqt35n-2": [_exp3()]
  }
}));
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "irhqjgv",
  propsAsIs: false
});
const BottomContentWrapper = /*#__PURE__*/styled('div')({
  name: "BottomContentWrapper",
  class: "b8hpwxn",
  propsAsIs: false
});
const MarqueeWrapper = /*#__PURE__*/styled('div')({
  name: "MarqueeWrapper",
  class: "m1dn35np",
  propsAsIs: false
});
const LabelWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "LabelWrapper",
  class: "lrjbwwx",
  propsAsIs: false
}));
const AmountWrapper = /*#__PURE__*/styled('div')({
  name: "AmountWrapper",
  class: "ae1m14p",
  propsAsIs: false
});
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "ij33y2n",
  propsAsIs: false
});
const ButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonWrapper",
  class: "b1cdtpp1",
  propsAsIs: false
});

require("./DenominationCard.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./DenominationCard.tsx");